module.exports = __webpack_public_path__ + "static/img/title-button-selected3.3888c1b5.png";